var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 10,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.47573 10C6.85625 10 8.1171 9.36851 8.95242 8.33373C9.07599 8.18066 8.94125 7.95704 8.75028 7.9936C6.57879 8.40939 4.58466 6.73543 4.58466 4.53152C4.58466 3.26199 5.2606 2.09457 6.35918 1.466C6.52853 1.36911 6.48594 1.11097 6.29352 1.07523C6.02376 1.02522 5.75004 1.00004 5.47573 1C3.00518 1 1 3.01289 1 5.5C1 7.98395 3.00203 10 5.47573 10Z",
    stroke: "current"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.f7fe6c05.svg";
export { ForwardRef as ReactComponent };